<template>
  <div v-if="$store.getters.marchand && $store.getters.marchand._env==='live'" class="row" style="padding: 5px">
    <loader v-show="loader" object="#29B3A6" color1="#29B3A6" color2="#17fd3d" size="4" speed="5" bg="#343a40" objectbg="#999793" opacity="80" name="spinning"></loader>
    <div class="container-fluid" v-if="$store.getters.marchand">
      <div class="col-12 mb-0 pb=0">
        <v-btn @click="$router.go(-1)" outlined style="border: none;background: #fff" title="Retourner">
          <v-icon>mdi mdi-arrow-left</v-icon> Intram Direct
         </v-btn>
      </div>
      <div class="col-12 pt-0 mt-0">
         <v-row >
           <v-col  cols="12" lg="4" md="4" class="mt-0 pt-0" v-if="!payment_link._archive">
            <v-card style="padding: 15px;">
              <div class="row"  style="background: #fff">
                <div class="col-md-12 pt-2 pb-0" style="cursor:pointer">
                 <a :href="payment_link._link" target="_blank"> {{ limiText(payment_link._link,24) }}</a> &nbsp;&nbsp; <v-icon @click="copieToClipboard(payment_link._link)" small>mdi-content-copy</v-icon>
                </div>
                <div class="col-md-12">
                  <div style="font-weight: bold;">Actions :</div>
                  <div style="font-weight: bold">
                    <button class="mr-2 mt-1 btn btn-warning btn-sm" @click="updateStatus" v-if="payment_link._active && !payment_link._archive && payment_link._status"> <v-icon style="color:#fff" small>mdi-gesture-tap</v-icon>Désactiver</button>
                    <button class="mr-2 mt-1 btn btn-success btn-sm" @click="updateStatus" v-if="!payment_link._active && !payment_link._archive && payment_link._status"> <v-icon style="color:#fff" small>mdi-gesture-double-tap</v-icon>Activer</button>
                    <button class="mr-2 mt-1 btn btn-primary btn-sm" v-if="!payment_link._archive && payment_link._status" @click="cloturer"> <v-icon style="color:#fff" small>mdi-send-outline</v-icon> Clôturer</button>
                    <button class="btn mt-1 btn-danger btn-sm" v-if="!payment_link._active && !payment_link._archive" @click="archived"> <v-icon style="color:#fff" small>mdi-trash-can-outline</v-icon> Archiver</button>
                    <!-- <button class="btn btn-light btn-sm"  @click="archived"> <v-icon small>mdi-microsoft-excel</v-icon> Exporter</button> -->
                      </div>
                </div>
              </div>

            </v-card>
          </v-col>
      <v-col  cols="12" lg="4" md="4" class="mt-0 pt-0">
        <v-card style="padding: 15px;">
          <div class="row" style="background: #fff">
            <div class="col-md-12 pt-2 pb-0">
              <v-icon large>mdi-collage</v-icon>
            </div>
            <div class="col-md-12 ">
              <div>Raison de la collecte :</div>
              <div style="font-weight: bold">
                  {{ payment_link._utility }}
              </div>
            </div>
          </div>

        </v-card>
      </v-col>
        <v-col  cols="12" lg="4" md="4" class="mt-0 pt-0">
        <v-card style="padding: 15px;">
          <div class="row" style="background: #fff">
            <div class="col-md-12 pt-2 pb-0">
              <v-icon large>mdi-archive</v-icon>
            </div>
            <div class="col-md-12 ">
              <div>Nom du produit :</div>
              <div style="font-weight: bold">
                  {{ payment_link._label }}
                  <span class="badge badge-info float-right" v-if="payment_link._status && payment_link._active && !payment_link._archive">Actif</span>
                  <span class="badge badge-warning float-right" v-if="!payment_link._active && payment_link._status && !payment_link._archive">Inactif</span>
                  <span class="badge badge-success float-right" v-if="!payment_link._status && !payment_link._archive">Clôturer</span>
                  <span class="badge badge-danger float-right" v-if="payment_link._archive">Archiver</span>
              </div>
            </div>
          </div>

        </v-card>
      </v-col>
      <v-col cols="12" lg="3" md="4" class="mt-0 pt-0">
        <v-card style="padding: 15px;">
          <div class="row"  style="background: #fff">
            <div class="col-md-12 pt-2 pb-0">
              <v-icon large>mdi-cash-100</v-icon>
            </div>
            <div class="col-md-12 ">
              <div>Montant à payer:</div>
              <div style="font-weight: bold" class="text-uppercase">
                  {{ payment_link._price }} XOF 
                  <span style="font-size: 7px!important;color:orange" :class="payment_link._fees_support ? ' float-right' : 'float-right'">(*{{payment_link._fees_support ? 'Frais supportés' : 'Frais non supportés'}}*)</span>
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col  cols="12" lg="2" md="3" class="mt-0 pt-0">
        <v-card style="padding: 15px;">
          <div class="row"  style="background: #fff">
            <div class="col-md-12 pt-2 pb-0">
              <v-icon large>mdi-cash-clock</v-icon>
            </div>
            <div class="col-md-12 ">
              <div>Type de Paiement:</div>
              <div style="font-weight: bold">
                <span v-if="payment_link._payment_type==='multi'" class="badge badge-warning">Paiement Mutiple</span>
                <span v-else  class="badge badge-info">Paiement Unique</span>
                  </div>
            </div>
          </div>

        </v-card>
      </v-col>
      <v-col  cols="12" lg="2" md="3" class="mt-0 pt-0">
        <v-card style="padding: 15px;">
          <div class="row"  style="background: #fff">
            <div class="col-md-12 pt-2 pb-0">
              <v-icon large>mdi-currency-usd-off</v-icon>
            </div>
            <div class="col-md-12 ">
              <div> Frais :</div>
              <div style="font-weight: bold">
                {{ fees }} XOF / Collecte
                  </div>
            </div>
          </div>

        </v-card>
      </v-col>
       <v-col  cols="12" lg="3" md="3" class="mt-0 pt-0">
        <v-card style="padding: 15px;">
          <div class="row"  style="background: #fff">
            <div class="col-md-12 pt-2 pb-0">
              <v-icon large>mdi-cash-multiple</v-icon>
            </div>
            <div class="col-md-12 ">
              <div>Montant total collecté:</div>
              <div style="font-weight: bold">
                {{ ((total_amount))}} XOF
                  </div>
            </div>
          </div>

        </v-card>
      </v-col>
       <v-col  cols="12" lg="2" md="3" class="mt-0 pt-0">
        <v-card style="padding: 15px;">
          <div class="row"  style="background: #fff">
            <div class="col-md-12 pt-2 pb-0">
              <v-icon large>mdi-account-badge-outline</v-icon>
            </div>
            <div class="col-md-12 ">
              <div>Nombre de collecte:</div>
              <div style="font-weight: bold">
                {{ (payment_link.payments.length)}}
                  </div>
            </div>
          </div>

        </v-card>
      </v-col>
      
    
    </v-row>
      </div>
      <v-card elevation="0">
        <div class="col-12 pt-0 mt-0">
          <h5>Liste des transactions liées à: <strong>{{ payment_link._label }}</strong></h5>
        <v-data-table
                :headers="headers"
                :items="payment_links_payment"
                :items-per-page="15"
                class="elevation-0"
                :loading="loadingTransactions"
                no-data-text="Aucune transaction trouvée"
                :search="search"
            >
            <template v-slot:item._created_at="{item}">
                  {{ new Date(item._created_at).toLocaleDateString() }}
                </template>
            </v-data-table>
           <div class="text-right" style="background : #f8f8f8">
                <v-pagination
                elevation="0"
                v-model="page"
                :length="total_pages"
                :total-visible="7"
                prev-icon="mdi-menu-left"
                next-icon="mdi-menu-right"
                @input="getPaymentLinksData"
                ></v-pagination>
              <!-- product pagination -->
        </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import {client} from "../../store/services/client";
import helpers from "../../mixins/helpers";

export default {
  name: "LinksDetails",
  mixins:[helpers(this)],
  data() {
    return {
      total_amount: 0,
      loader:false,
      total_pages: 0,
      fees: 0,
      page: 1,
      openPaiementLogs:false,
      loadingTransactions:false,
      search: "",
      transactions: undefined,
      filter:'',
      date: new Date().toISOString().substr(0, 10),
      payment_link:{},
      payment_links_payment:[]
    }
  },
  methods: {
    checkisDashboard() {
      this.$emit('checkisDashboard', true);
    },
    initialize(){
      this.getPaymentLinksData()
    },
       async getPaymentLinksData(page=1){
         this.loadingTransactions=true
          page=page-1;
        const response = await client({
          method: 'post',
          url: `/payment/link/get/by/id`,
          data: {id : this.$route.params.details, page:page }
        })
            .then(res => res.data)
            .catch(error => {
              console.log(error)
              return {
                error: true
              }
            })
        if(response && !response.error)
          this.payment_link = response.paymentLinks
          this.fees = response.fees
          this.total_amount = response.total_amount
          this.payment_links_payment = response.paymentLinks && response.paymentLinks.payments ? response.paymentLinks.payments : []
          this.loadingTransactions=false
          this.loader=false
          this.page=response.page+1;
          this.total_pages = response.total_pages;
        },
  async updateStatus(){
         this.loader=true
        const response = await client({
          method: 'post',
          url: `/payment/link/status/update/`,
          data: {id : this.$route.params.details}
        })
            .then(res => res.data)
            .catch(error => {
              this.toast('error','Echec ! Une erreur est survenue')
              console.log(error)
              return {
                error: true
              }
            })
        if(response && !response.error)
        this.toast('success',response.message)
          this.loader=false;
          this.getPaymentLinksData()
        },
      async archived(){
         this.loader=true
        const response = await client({
          method: 'post',
          url: `/payment/link/archive`,
          data: {id : this.$route.params.details}
        })
            .then(res => res.data)
            .catch(error => {
              this.toast('error','Echec ! Une erreur est survenue')
              console.log(error)
              return {
                error: true
              }
            })
        if(response && !response.error)
        this.toast('success',response.message)
          this.loader=false;
          this.getPaymentLinksData()
        },
      async cloturer(){
         this.loader=true
        const response = await client({
          method: 'post',
          url: `/payment/link/cloturer`,
          data: {id : this.$route.params.details}
        })
            .then(res => res.data)
            .catch(error => {
              this.toast('error','Echec ! Une erreur est survenue')
              console.log(error)
              return {
                error: true
              }
            })
        if(response && !response.error)
        this.toast('success',response.message)
          this.loader=false;
          this.getPaymentLinksData()
        }
  },
  computed: {
    headers: function(){
      return [
        {text: 'Nom', value: '_last_name'},
        {text: 'Prenom', value: '_first_name'},
        {text: 'Email', value: '_email'},
        {text: 'Téléphone', value: '_phone'},
        {text: 'Date', value: '_created_at'},
      ]
    },
  },
  created(){
    this.loader=true
    this.checkisDashboard();
    this.initialize()
  }
}
</script>

<style scoped>

</style>
